import React from "react";
import ProgressBar from "@via/components/progress-bar/progress-bar.tsx";

interface CapacityBarProps {
  current: number;
  capacity: number;
  labelPosition?: "bottom" | "right";
  color?: string;
}

const CapacityBar: React.FC<CapacityBarProps> = ({
  current,
  capacity,
  labelPosition = "bottom",
  color = "bg-indigo-600",
}) => {
  const progress = Math.min((current / capacity) * 100, 100);
  const isVertical = labelPosition === "bottom";

  return (
    <div
      className={`flex ${
        isVertical ? "flex-col items-start" : "flex-row items-center gap-2"
      } w-full`}>
      <div className="w-full">
        <ProgressBar progress={progress} color={color} showPercentage={false} />
      </div>

      <div className={`${isVertical ? "mt-2" : "ml-2"} text-sm text-gray-800`}>
        <span className="font-bold">
          {current}/{capacity}
        </span>{" "}
        Free seats left
      </div>
    </div>
  );
};

export default CapacityBar;
